import React from 'react'
import { PageContainer } from './LandingPage.style'
import Header from 'Components/Header/Header'
import Footer from '../Footer/Footer'
import HeroBanner from './HeroBanner'
import WhoWeAre from './WhoWeAre'
import Mastering from './Mastering'
import SubscriptionPlansSection from './SubscriptionPlansSection'
import TestimonialsSection from './TestimonialsSection'
// Images
// import HeroImage from "../../Assets/Images/LandingPage/hero_image.png";


// Import typography styles
import '../../Styles/typography.css';
import MobileHeader from '../Header/MobileHeader'

const LandingPage = () => {
  return (
    <PageContainer className="home_landing-wrapper">
      {/* For Desktop screen */}
      <Header />

      {/* For mobile screen */}
      <MobileHeader />

      <HeroBanner />
      <WhoWeAre />

      <Mastering />
      <SubscriptionPlansSection />

      <TestimonialsSection />

      <Footer />
    </PageContainer>
  )
}

export default LandingPage